import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import ButtonWithIcon from './ButtonWithIcon';
import { addSection, removeSection } from '../modules/calculation';
import { getUIText } from '../utils/index';

class SectionsRow extends Component {

  state = {
    value: 0,
    scrolling: false
  }

  tabOnClickHandler = (value) => {
    if(this.props.onChange) {
      this.props.onChange(value);
    }
  }

  render() {
    const {
      project,
      add,
      remove,

      translations,
      app,
    } = this.props;

    const {
      calculations,
      calculationIndex
    } = project;

    const {
      sectionIndex,
      sections
    } = calculations ? calculations[calculationIndex] : {};

    let tabs = sections.map( (item, index) => {
      return <li key={index} className={'tab animated fadeIn ' + (index === sectionIndex ? ' selected' : '') + (index === sectionIndex - 1 ? ' previous' : '')} onClick={this.tabOnClickHandler.bind(this, index)}><span className="order-number">{index + 1}:</span> {item.length}m</li>;
    });

    tabs.push(<li key={9999} className="tab icon" onClick={() => add()}><i className="fa fa-plus-circle" /></li>);

    if(sections.length > 1) {
      tabs.push(<li key={10001} className="tab remove" ><ButtonWithIcon icon="fa fa-trash" onClick={() => remove(sectionIndex)} label={getUIText('CALCULATION-REMOVE_SECTION', app.language, translations)} /></li>);
    } else {
      tabs.push(<li key={10001} className="tab none" ></li>);
    }

    return (
      <div className="card">
        <div className="sections">
          <div className="section-header">{getUIText('CALCULATION-SECTIONS', app.language, translations)}</div>
          <div className="tabs">
            <ul>
              {tabs}
            </ul>
          </div>
        </div>
      </div>
    );
  }
}

SectionsRow.propTypes = {
    project: PropTypes.object,
    translations: PropTypes.object,
    app: PropTypes.object,
    onChange: PropTypes.func,
    add: PropTypes.func,
    remove: PropTypes.func,
};

const mapStateToProps = (state) => {
    return {
        project: state.project,
        translations: state.translations,
        app: state.app,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
      add: () => dispatch(addSection()),
      remove: index => dispatch(removeSection({ index })),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SectionsRow);
